(() => {
  const findDrawer = (drawerId) =>
    document.querySelector(`x-drawer[id$="${drawerId}"]`);

  const closeAccordion = (trigger) => {
    const accordion = trigger.closest('accordion-disclosure');
    if (!accordion) {
      return;
    }

    accordion.classList.remove('is-open');
    const details = accordion.querySelector('details');
    if (!details) {
      return;
    }

    details.open = false;
    details.style.height = null;
    details.style.overflow = null;
  };

  const getAccordionContent = (trigger) => {
    const accordion = trigger.closest('accordion-disclosure');
    if (!accordion) {
      return '';
    }

    const content = accordion.querySelector('.accordion__content');
    return content ? content.innerHTML.trim() : '';
  };

  const getContentFromIds = (contentIds) => {
    if (!contentIds) {
      return '';
    }

    const ids = contentIds
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    if (!ids.length) {
      return '';
    }

    const fragments = ids
      .map((id) => document.querySelector(`[id$="${id}"]`))
      .filter(Boolean)
      .map((element) => element.innerHTML.trim())
      .filter(Boolean);

    return fragments.join('');
  };

  const populateDrawerContent = (drawer, trigger) => {
    const prose = drawer.querySelector('.prose');
    if (!prose) {
      return;
    }

    const accordion = trigger.closest('accordion-disclosure');
    const contentIds = accordion ? accordion.dataset.contentIds : '';
    const content = contentIds
      ? getContentFromIds(contentIds)
      : getAccordionContent(trigger);

    prose.innerHTML = content;
  };

  const handleAccordionDrawerClick = (event) => {
    const trigger = event.target.closest('.accordion-drawer');
    if (!trigger) {
      return;
    }

    const drawerId = trigger.dataset.drawerId;
    if (!drawerId) {
      return;
    }

    const drawer = findDrawer(drawerId);
    if (!drawer) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    closeAccordion(trigger);
    populateDrawerContent(drawer, trigger);
    drawer.show();
  };

  document.addEventListener('click', handleAccordionDrawerClick, true);
})();